<template>
  <div class="capitalize">
    <div class="flex space-x-2 items-center">
      <button :disabled="loading" type="submit" class="primary-button">
        <div class="flex items-center text-white space-x-2 justify-center">
          <template v-if="icon">
            <vk-icon :icon="icon" />
          </template>
          <span> {{ title }}</span>
        </div>
      </button>
      <template v-if="loading == true">
        <span class="text-gray-400">
          <vk-spinner ratio="0.6" />
        </span>
      </template>
      <template v-if="success == true">
        <span class="text-jgreen-400">
          <div class="flex items-center justify-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="w-6 h-6"
              viewBox="0 0 14 14"
            >
              <!-- Onaylama simgesi -->
              <g
                fill="none"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path
                  d="m4 8l2.05 1.64a.48.48 0 0 0 .4.1a.5.5 0 0 0 .34-.24L10 4"
                />
                <circle cx="7" cy="7" r="6.5" />
              </g>
            </svg>
          </div>
        </span>
      </template>
    </div>
  </div>
</template>

<script>
import EventBus from "./EventBus";
export default {
  props: {
    action: { type: String, required: false, default: "SaveButton" },
    title: { type: String, required: false, default: "Kaydet" },
    icon: { type: String, required: false },
    color: { type: String, required: false }
  },
  data() {
    return {
      loading: false,
      success: false
    };
  },
  mounted() {
    EventBus.$on("loadingStatus", val => {
      if (this.action == val.action) {
        this.loading = val.loading;
        this.success = val.success;

        setTimeout(e => {
          this.success = false;
        }, 1000);
      }
    });
  }
};
</script>

<style></style>
